import { put, takeLatest } from "@redux-saga/core/effects";

import AxiosCustom from "../../../common/components/apiConfig";
import { handleNotificationAlertTryUpdate ,handleNotificationAlertCatch,handleNotificationAlertTrySelect} from "../../../common/method/handleNotificationAlert";



 export const actionTypes={
    selectSuperiorIndustries:"[selectSuperiorIndustries] Action",
    selectSuperiorIndustriesLoad:"[selectSuperiorIndustriesLoad] Action",
    selectSuperiorIndustriesAsync:"[selectSuperiorIndustriesAsync] Action",
}





const initialState = {
    data:[],
    loading:false
}

 export const select_superior_industries_reducer = (state=initialState,{type,payload})=>{

    switch (type) {
        case actionTypes.selectSuperiorIndustries:
            return{
                ...state,
                data: payload?.data?.results ? payload?.data?.results : [],
            }
        case actionTypes.selectSuperiorIndustriesLoad:
            return{
                ...state,
                loading:payload
                          }
        default:
            return state;
    }
}




function* handleWorker({ payload }) {
    yield put({ type: actionTypes.selectSuperiorIndustriesLoad, payload: true });
    let config = {
        url: "select_request"
    };
    
    let data = {
        table: "portfolio",
        method_type: "select_superior_industries",
        data: payload?.data ? payload.data : {},
        sort_by:{value:"desc"}
    };
    
    try {
      let res = yield AxiosCustom(config, data);

      yield put({type:actionTypes.selectSuperiorIndustries,payload:res.data.response})
    } catch {
      handleNotificationAlertCatch();
    }
    finally{
      yield put({ type: actionTypes.selectSuperiorIndustriesLoad, payload: false });

    }
  }
  
  export function* selectSuperiorIndustries() {
      
    yield takeLatest(actionTypes.selectSuperiorIndustriesAsync, handleWorker);
  }